import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import Icon from "../../../components/Icon";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ErrorMessage from "../../../components/ErrorMessage";
import { authContext } from "../../../context/AuthContext/AuthContext";
import {
  sendPhoneNumberOTPValidation,
  verifyPhoneNumberOTPValidation,
} from "../../../utils/validation/validation";
import OperatorIcon from "../../../components/OperatorIcon";

const LogInOTPAuth = () => {
  const { handleSendLoginOtp, handleVerifyLoginOtp } = useContext(authContext);

  const {
    watch: pnWatch,
    register: pnRegister,
    handleSubmit: pnHandleSubmit,
    formState: { errors: pnErrors },
  } = useForm({
    resolver: yupResolver(sendPhoneNumberOTPValidation),
  });
  const {
    register: vpRegister,
    handleSubmit: vpHandleSubmit,
    setValue: vpSetValue,
    watch: vpWatch,
    formState: { errors: vpErrors },
  } = useForm({
    resolver: yupResolver(verifyPhoneNumberOTPValidation),
  });

  const isSendCode = !!vpWatch("phoneNumber");
  const handleSubmit = isSendCode ? vpHandleSubmit : pnHandleSubmit;
  const handleSubmitForm = isSendCode
    ? handleVerifyLoginOtp
    : (d) => handleSendLoginOtp(d, vpSetValue);
  const register = isSendCode ? vpRegister : pnRegister;
  const errors = isSendCode ? vpErrors : pnErrors;
  const watch = isSendCode ? vpWatch : pnWatch;

  return (
    <>
      <SiteTitle title="ورود به حساب کاربری" />

      <section className="auth bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="/assets/images/auth/auth-img.png" alt="" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div className="text-center">
              <Link to="/" className="mb-40 max-w-290-px">
                <img src="/assets/images/logo.jpg" alt="" />
              </Link>
              <h4 className="mb-12">ورود به حساب کاربری</h4>
              <p className="mb-32 text-secondary-light text-lg">
                به <span className="text-primary fw-semibold">آکسون</span> خوش
                آمدید، لطفا اطلاعات حساب خود را وارد کنید
              </p>
            </div>
            <form autoComplete="off" onSubmit={handleSubmit(handleSubmitForm)}>
              <div className="mb-20">
                <div className="position-relative ">
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="quill:phone" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      placeholder="شماره موبایل"
                      inputMode="numeric"
                      {...register("phoneNumber")}
                    />
                  </div>
                  <OperatorIcon phoneNumber={watch("phoneNumber")} />
                </div>
                {isSendCode && (
                  <span
                    onClick={() => vpSetValue("phoneNumber", "")}
                    className="text-primary fw-semibold text-sm cursor-pointer text-end d-block"
                  >
                    ویرایش شماره موبایل
                  </span>
                )}
                <ErrorMessage message={errors.phoneNumber?.message} />
              </div>
              {isSendCode && (
                <div className="mb-20">
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="solar:password-broken" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12 text-center"
                      placeholder="کد تایید"
                      {...register("otp")}
                    />
                  </div>

                  <ErrorMessage message={errors.otp?.message} />
                </div>
              )}
              <button
                type="submit"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              >
                {" "}
                {isSendCode ? "ورود به حساب کاربری" : "ارسال کد"}
              </button>
              <div className="mt-32 center-border-horizontal text-center">
                <span className="bg-base z-1 px-4">یا ورود از طریق</span>
              </div>
              <div className="mt-32">
                <Link
                  to="/auth/login"
                  type="button"
                  className="fw-semibold text-primary-light py-16  border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
                >
                  <Icon
                    icon="solar:lock-password-bold"
                    className="text-primary-600 text-xl line-height-1"
                  />
                  کلمه عبور
                </Link>
              </div>
              <div className="mt-32 text-center text-sm">
                <p className="mb-0">
                  حساب کاربری ندارید؟{" "}
                  <Link
                    to="/auth/register"
                    className="text-primary-600 fw-semibold"
                  >
                    ثبت نام کنید
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default LogInOTPAuth;
